import { GatsbyLinkProps, Link as GatsbyLink } from 'gatsby'
import React, { Component } from 'react'

type Props = GatsbyLinkProps<any>

export class Link extends Component<Props> {
  render() {
    if (this.props.to.indexOf(':') >= 0) {
      return (
        <a href={this.props.to} {...this.props}>
          {this.props.children}
        </a>
      )
    }

    return <GatsbyLink {...(this.props as any)}>{this.props.children}</GatsbyLink>
  }
}
